import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AutosizeModule } from 'ngx-autosize';
import { CommonModule } from '@angular/common';
import { ContentEditableModelDirective } from './helpers/content-editable-model.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FbAttachmentComponent } from './form-element/components/fb-attachment/fb-attachment.component';
import { FbCheckboxCompositeComponent } from './form-element/components/fb-checkbox-composite/fb-checkbox-composite.component';
import { FbContentSectionComponent } from './form-element/components/fb-content-section/fb-content-section.component';
import { FbDropdownComponent } from './form-element/components/fb-dropdown/fb-dropdown.component';
import { FbHeaderComponent } from './form-element/components/fb-header/fb-header.component';
import { FbImageComponent } from './form-element/components/fb-image/fb-image.component';
import { FbLabelComponent } from './form-element/components/fb-label/fb-label.component';
import { FbMatrixComponent } from './form-element/components/fb-matrix/fb-matrix.component';
import { FbRadioCompositeComponent } from './form-element/components/fb-radio-composite/fb-radio-composite.component';
import { FbRadioSimpleComponent } from './form-element/components/fb-radio-simple/fb-radio-simple.component';
import { FbRicheditComponent } from './form-element/components/fb-richedit/fb-richedit.component';
import { FbSignatureComponent } from './form-element/components/fb-signature/fb-signature.component';
import { FbTextComponent } from './form-element/components/fb-text/fb-text.component';
import { FbTextareaComponent } from './form-element/components/fb-textarea/fb-textarea.component';
import { FbTextboxComponent } from './form-element/components/fb-textbox/fb-textbox.component';
import { FormElementComponent } from './form-element/form-element.component';
import { HelpersModule } from './helpers/helpers.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { RxDirectivesModule } from '@nrwl/rx-directives';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxRicheditModule } from '@nrwl/rx-richedit';
import { RxUploadModule } from '@nrwl/rx-upload';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatDividerModule } from '@angular/material/divider';
import { SanitizeUrlPipe } from './form-element/components/fb-image/sanitize-url.pipe';
import { ConditionalMenuTriggerDirective } from './form-element/components/fb-attachment/conditional-menu.directive';
import { TokenToDivDirective } from './helpers/token-to-div.directive';
import { TokenToDivPipe } from './helpers/token-to-div.pipe';
import { DateFormatPipe } from './helpers/date-format.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RxFormPresenterComponent } from './rx-form-presenter';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    ScrollingModule,
    AutosizeModule,
    MatExpansionModule,
    MatRadioModule,
    MatCheckboxModule,
    MatIconModule,
    HelpersModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatSelectModule,
    NgSelectModule,
    RxIconModule,
    RxDirectivesModule,
    RxRicheditModule,
    RxUploadModule,
    MatDividerModule,
    PdfViewerModule,
    FormElementComponent,
    FbLabelComponent,
    FbTextboxComponent,
    FbHeaderComponent,
    FbCheckboxCompositeComponent,
    FbImageComponent,
    FbRadioCompositeComponent,
    FbRicheditComponent,
    FbSignatureComponent,
    FbMatrixComponent,
    FbTextareaComponent,
    FbRadioSimpleComponent,
    FbTextComponent,
    FbDropdownComponent,
    FbContentSectionComponent,
    FbAttachmentComponent,
    ContentEditableModelDirective,
    SanitizeUrlPipe,
    ConditionalMenuTriggerDirective,
    TokenToDivDirective,
    TokenToDivPipe,
    DateFormatPipe,
    RxFormPresenterComponent,
  ],
  exports: [
    FormElementComponent,
    FbLabelComponent,
    FbTextboxComponent,
    FbHeaderComponent,
    FbCheckboxCompositeComponent,
    FbImageComponent,
    FbRadioCompositeComponent,
    FbRicheditComponent,
    FbSignatureComponent,
    FbMatrixComponent,
    FbTextareaComponent,
    FbRadioSimpleComponent,
    FbTextComponent,
    FbDropdownComponent,
    FbAttachmentComponent,
    TokenToDivDirective,
    RxFormPresenterComponent,
  ],
})
export class RxFormBuilderModule {}
